import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const EmailStatus = ({ is_active, is_unsubscribed }) => {
  let color = is_active ? '#00C800' : '#A6ADB3';
  color = is_unsubscribed ? '#FF9700' : color;
  let icon = is_unsubscribed ? 'exclamation-triangle' : 'circle';
  let text = is_active ? 'On' : 'Off';
  text = is_unsubscribed ? 'Unsubscribed' : text;
  return (
    <div>
      <FontAwesomeIcon icon={icon} color={color} /> {text}
    </div>
  );
};

const ListUserConfigs = ({ configs, toggleEditConfig }) => {
  const columns = [
    {
      id: 'user_name',
      Header: 'Name',
      sortable: true,
      accessor: ({ user_name }) => user_name,
    },
    {
      id: 'user_role',
      Header: 'Business Account',
      sortable: true,
      accessor: ({ user_role }) => user_role,
    },
    {
      id: 'email_report',
      Header: 'Email Reports',
      sortable: true,
      Cell: ({ original: { is_active, is_unsubscribed } }) => (
        <EmailStatus is_active={is_active} is_unsubscribed={is_unsubscribed} />
      ),
    },
    {
      id: 'email_interval',
      Header: 'Email Interval',
      sortable: true,
      accessor: ({ email_interval: emailInterval }) => (
        <div className="text-capitalize">
          {emailInterval ? emailInterval.replace('_', ' ') : emailInterval}
        </div>
      ),
    },
    // TODO: Uncomment when implementing edit modal
    // {
    //   id: 'action',
    //   Header: 'Actions',
    //   sortable: false,
    //   Cell: ({ original }) => (
    //     <div
    //       className="circular-icon icon-check ml-0"
    //       onClick={() => toggleEditConfig(original)}
    //     >
    //       <FontAwesomeIcon icon="pencil-alt" />
    //     </div>
    //   ),
    // },
  ];

  const minRows = configs.length ? 0 : 2;

  return (
    <div>
      <ReactTable
        className="styled-box-shadow bg-white"
        data={configs}
        columns={columns}
        resizable={false}
        sortable={false}
        minRows={minRows}
        showPagination={false}
      />
    </div>
  );
};

ListUserConfigs.propTypes = {
  configs: PropTypes.arrayOf(
    PropTypes.shape({
      is_active: PropTypes.bool,
      is_unsubscribed: PropTypes.bool,
      email_interval: PropTypes.string,
    })
  ).isRequired,
};

export default ListUserConfigs;



// WEBPACK FOOTER //
// ./src/components/emailConfig/list/ListUserConfigs.js